import {IStoreReady} from '@/store/lib/storeSupport';
import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";
import {WorkerAddRequestType} from "@/form/workerAdd/workerAdd.types";
import {ResponseDataType} from "@/form/form.types";

@Module({
    namespaced: true,
    name: 'workers',
    store,
    dynamic: true,
})
class WorkersModule extends VuexModule implements IStoreReady {
    workers: IWorkers | null = null
    worker: IWorkersListItem | null = null
    workerLoaded = false
    workersLoaded = false
    ready = false


    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ workers: IWorkers; workersLoaded: boolean }> {
        let workersLoaded = false;
        const workers = await store.$repository.workers.fetchAll(data);
        if (workers) {
            workersLoaded = true;
        }
        return {workers, workersLoaded};
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ worker: IWorkersListItem; workerLoaded: boolean }> {
        let workerLoaded = false;
        const worker = await store.$repository.workers.fetchData(data);
        if (worker) {
            workerLoaded = true;
        }
        return {worker, workerLoaded};
    }

    @Action({rawError: true})
    async create(data: WorkerAddRequestType): Promise<ResponseDataType> {
        return await store.$repository.workers.create(data);
    }

    @Action({rawError: true})
    async update(data: WorkerAddRequestType): Promise<ResponseDataType> {
        return await store.$repository.workers.update(data);
    }

    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        return await store.$repository.workers.delete({id: id});
    }

    @Mutation
    setReady(st: boolean) {
        this.ready = st
    }

}

export const WorkersStore = getModule(WorkersModule);
